// removed by extract-text-webpack-plugin
module.exports = {"ribbon":"src-components----facts-module---ribbon---RxLtf","facts":"src-components----facts-module---facts---g1nmh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/facts.module.css
// module id = 381
// module chunks = 35783957827783